import {Component, OnInit} from '@angular/core';
import {Globals} from '../../_models/globals';
import {ApiIntegration} from '../../_services/api.integration';
import {User} from '../../_models/user';
import {DataTableDirective} from 'angular-datatables';
import {AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AlertService} from '../../_services/alert.service';
import {OrderMenu} from '../../_models/orderMenu';
//import {LocalStorageService, SessionStorageService, LocalStorage, SessionStorage} from 'angular-web-storage';

@Component({
  selector: 'app-admin-returns',
  templateUrl: './admin-returns.component.html',
  styleUrls: ['./admin-returns.component.scss'],
})
export class AdminReturnsComponent implements OnInit {

  adminReturnMainMenu: OrderMenu[] = [
    {displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N"},
    {displayName: "Submitted", tabClicked: "submitted", orderStatus: "SUBMITTED", additional: "N"},
    {displayName: "Pickup Requested", tabClicked: "requestForPickUp", orderStatus: "AWAITING_CARRIER", additional: "N"},
    {displayName: "In Transit", tabClicked: "inTransit", orderStatus: "IN_TRANSIT", additional: "N"},
    /* {displayName: "Received", tabClicked: "received", orderStatus: "RECEIVED", additional: "N"},*/
    {displayName: "Delivered/ Return to origin", tabClicked: "completed", orderStatus: "RTO", additional: "Y"},
    {displayName: "Cancelled", tabClicked: "cancelled", orderStatus: "CANCELLED", additional: "Y"}
  ];

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  tabClicked: string = "all";

  orders: any;
  errorMessage: string;
  checkedList = [];
  otpPopUp: string = 'N';
  masterSelected: boolean = false;
  previousStatus = '';
  orderStatus: any = 'ALL';
  password1: string;
  password2: string;
  password3: string;
  password4: string;
  otp: string;
  totalRecords: number;
  userDrop2: any = 'ALL';
  meta = {};

  constructor( private alertService: AlertService, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration, public user: User) {
    this.g.page = "Returns";
    this.tabClicked = this.g.pageTab;
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.adminReturnMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getStockTransferAccountOwnerByStatus(orderStatus);
    } else {
      this.rerender();
    }

  }

  populate(orderChange) {
    this.api.adminGetReturnOrderList(orderChange, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.responseList;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  switchPosition(om) {
    let index = this.adminReturnMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.adminReturnMainMenu[5].displayName) {
      this.adminReturnMainMenu[5].additional = 'Y';
    }
    var tmp = 4;
    for (let o of this.adminReturnMainMenu) {
      if (tmp < this.adminReturnMainMenu.length) {
        if (om.displayName !== this.adminReturnMainMenu[tmp].displayName) {
          this.adminReturnMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  tabChange() {
    this.checkedList = [];
    this.g.loaderDisplay = "display";
  }

  getStockTransferAccountOwner(status) {
    this.g.loaderDisplay = "display";
    this.api.getStockTransferAccountOwner(this.user.accountOwnerId, status, "ORDER", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.ordersData;
      this.orders.forEach((s) => {
        s['isSelected'] = false;
      });
      this.rerender()
      ;
    }, err => {
      this.g.loaderDisplay = ""
      console.log(err);
    });
  }

  selectShip(r) {
    if (!r.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }


  checkUncheckAll() {
    for (var i = 0; i < this.orders.length; i++) {
      this.orders[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }


  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList.push(this.orders[i]['orderHeaderId']);
      }
    }

  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  }

  editReturns(orders) {
    let i = 0;
    let ohid;
    for (let o of orders) {
      if (o.isSelected) {
        i = i + 1;
        ohid = o.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/createReturns/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
    }
  }


  cancelMultiReturnOrders(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected) {
        this.returnOrderCancel(order);
      }
    }
    ;
  }


  selectCarrier(orders) {
    let i = 0;
    let ohid;
    for (let o of orders) {
      if (o.isSelected) {
        i = i + 1;
        ohid = o.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/ProcessingOrder/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
    }
  }

  closePopUp() {
    this.otpPopUp = 'N';
    this.errorMessage = "";
    this.password1 = "";
    this.password2 = "";
    this.password3 = "";
    this.password4 = "";
    this.otp = "";
  }

  assignedPopUp(p) {

    this.otpPopUp = 'Y';
    this.errorMessage = "";
  }


  keytab(event, val1, val2) {
    if (event.key == 'Backspace') {
      document.getElementById(val2).focus();
    } else {
      document.getElementById(val1).focus();
    }
  }

  assignedPick(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.assignedPopUp(ohid);
    } else {
      this.errorMessage = "Can not Select multiple Return Orders . Please select one at a time";
    }
  }

  ngOnInit() {
  }

  getStockTransferAccountOwnerByStatus(status) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER") {
          query.accountOwnerId = this.user.accountOwnerId;
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + "api/return-orders", {params: query, headers: header1})
          .subscribe((data: any) => {
              this.orders = data.responseList;
              this.g.loaderDisplay = "";
              this.orders.forEach((s) => {
                s['isSelected'] = false;
              });
              this.totalRecords = data.noOfOrders;
              callback({
                recordsTotal: data.noOfOrders,
                recordsFiltered: data.noOfOrders
              });
            },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  returnOrderCancel(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateReturnOrder', {
        "accountOwnerId": this.user.accountOwnerId || ord.accountOwnerId,
        "orderStatus": "CANCELLED",
        "organizationId": 1,
        "returnOrderHeaderId": ord.orderHeaderId,
      },
      {headers: header1}).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Return Order', 'Cancelled Successfully');
          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }


  returnOrderInTransit(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateReturnOrder', {
        "accountOwnerId": this.user.accountOwnerId || ord.accountOwnerId,
        "orderStatus": "IN_TRANSIT",
        "organizationId": 1,
        "returnOrderHeaderId": ord.orderHeaderId,
      },
      {headers: header1}).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Return Order', 'In Transit Successfully');
          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  returnOrderCompleted(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateReturnOrder', {
        "accountOwnerId": this.user.accountOwnerId || ord.accountOwnerId,
        "orderStatus": "COMPLETED",
        "organizationId": 1,
        "returnOrderHeaderId": ord.orderHeaderId,
      },
      {headers: header1}).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Return Order', 'Completed Successfully');
          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  otpSubmit() {
    this.otp = this.password1 + this.password2 + this.password3 + this.password4;

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStatusToDelivered',
      {
        "mobileOtp": this.otp,
        "status": "RECEIVED"
      },
      {headers: header1}).subscribe(data => {
        if (data['code'] == 200) {
          this.alertService.success('Status', 'Update successfully');
        }
        {

          if (data['code'] == 400) {
            this.alertService.error('Error', data['message']);
          }
        }
        this.g.loaderDisplay = "";
      },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";

      });
  }

  submitResend() {

  }

}

